import React, { useState, useEffect } from 'react';
import { useDebounce } from 'use-debounce';
import { connect, useDispatch } from "react-redux";
import { authActions, fazendaAction, motivoDesistenciaAction, logAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import { history } from '../_helpers';
import Select from 'react-select';
import { formatCpf, formatCnpj } from '../../src/_utils/stringUtils'
import { Button, Container, Row, Col, Card, CardBody, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip, Input, Badge } from 'reactstrap';
import NavBar from '../_components/navbar';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faPen, faTrash, faClock, faMapMarkerAlt, faBuilding, faIdCard, faLeaf, faChevronLeft, faChevronRight, faSearch, faTimes, faWarehouse } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2';
import { ModalLog } from '../log/modalLog.component';

const Fazenda = (props) => {

    const [id, setId] = useState(-1);
    const [term, setTerm] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(12); // Grid view usually fits 12 better (3x4 or 4x3)
    const [open, setOpen] = useState(false);
    const [motivoSelecionado, setMotivoSelecionado] = useState(0);
    const [fazendaSelecionada, setFazendaSelecionada] = useState(0);
    const [valueDebounce] = useDebounce(term, 1000);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const toggle = () => setModal(!modal);
    const [modal, setModal] = useState(false);

    useEffect(() => {
        dispatch(motivoDesistenciaAction.getSelectMotivos());
    }, []);

    useEffect(() => {
        dispatch(fazendaAction.getFazenda(true, page, limit, valueDebounce));
    }, [page, limit, valueDebounce]);

    const { fazenda, totalItems } = props.fazenda;
    const { log } = props.log;

    const handleClickOpen = (event, idFazendaSelecionada) => {
        setFazendaSelecionada(idFazendaSelecionada);
        setOpen(true)
    };

    const handleClickHistory = (event, id) => {
        if (id) {
            setId(id);
            dispatch(logAction.clear());
            dispatch(logAction.getLog('Fazenda', id));
            toggle();
        }
    };

    const handleClose = () => {
        setOpen(false)
    };

    const handleChange = event => {
        setTerm(event.target.value);
        setPage(1);
    };

    const handleClick = () => {
        let payload = {
            id_motivo_desistencia: motivoSelecionado
        };

        if (fazendaSelecionada != null && fazendaSelecionada != 0 && motivoSelecionado != null && motivoSelecionado != 0) {
            dispatch(fazendaAction.deleteFazendaById(fazendaSelecionada, payload, true));
            handleClose();

        } else if (!motivoSelecionado) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>Selecione um motivo para a exclusão da fazenda</ul></div>'
            });
        }
    };

    const renderOptionsMotivo = () => {
        return props.motivoDesistencia?.motivoDesistencia?.map((p, i) => {
            return (
                { value: p.Value, label: p.Text }
            );
        });
    };

    const handleSelectChange = prop => event => {
        if (prop == 'motivo') {
            setMotivoSelecionado(event.value);
        }
    };

    const totalPages = Math.ceil(totalItems / limit);

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '60px' }}>
            <NavBar {...props} />
            <Container className="py-5">
                {/* Header Section */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5">
                    <div className="mb-3 mb-md-0">
                        <h2 className="font-weight-bold text-dark mb-1">Fazendas</h2>
                        <p className="text-muted mb-0">Gerencie suas propriedades e unidades produtivas</p>
                    </div>

                    <div className="d-flex align-items-center flex-column flex-sm-row">
                        <div className="position-relative mr-0 mr-sm-3 mb-3 mb-sm-0 w-100" style={{ maxWidth: '300px' }}>
                            <Input
                                id="term"
                                placeholder="Buscar por nome, cidade..."
                                value={term}
                                onChange={handleChange}
                                style={{
                                    paddingLeft: '40px',
                                    borderRadius: '50px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                                    height: '45px'
                                }}
                            />
                            <FontAwesomeIcon
                                icon={faSearch}
                                className="text-muted position-absolute"
                                style={{ left: '15px', top: '50%', transform: 'translateY(-50%)' }}
                            />
                            {term && (
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="text-muted position-absolute cursor-pointer"
                                    onClick={() => { setTerm(''); setPage(1); }}
                                    style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                />
                            )}
                        </div>

                        {authActions.isGestor() && (
                            <>
                                <Button
                                    id="btnNovo"
                                    color="primary"
                                    className="btn-rounded px-4 shadow-sm border-0 d-flex align-items-center"
                                    style={{ borderRadius: '50px', fontWeight: '600', height: '45px' }}
                                    onClick={() => navigate("/fazenda")}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                                    <span className="text-nowrap">Nova Fazenda</span>
                                </Button>
                                <UncontrolledTooltip placement="bottom" target="btnNovo">
                                    Adicionar nova fazenda
                                </UncontrolledTooltip>
                            </>
                        )}
                    </div>
                </div>

                {/* Grid Section */}
                {fazenda && fazenda.length > 0 ? (
                    <>
                        <Row>
                            {fazenda.map((item) => (
                                <Col xs={12} md={6} lg={4} className="mb-4" key={item.id}>
                                    <Card className="h-100 border-0 shadow-sm hover-cards" style={{ borderRadius: '16px', overflow: 'hidden', transition: 'all 0.3s ease' }}>
                                        <CardBody className="p-4 d-flex flex-column position-relative">

                                            {/* Status/Badge Area if needed */}
                                            <div className="d-flex align-items-start mb-4">
                                                <div className="d-flex justify-content-center align-items-center bg-light text-success rounded-circle mr-3"
                                                    style={{ width: '56px', height: '56px', backgroundColor: 'var(--primary-light)' }}>
                                                    <FontAwesomeIcon icon={faWarehouse} size="lg" />
                                                </div>
                                                <div style={{ overflow: 'hidden' }}>
                                                    <h5 className="mb-1 font-weight-bold text-dark text-truncate" title={item.nome}>
                                                        {item.nome}
                                                    </h5>
                                                </div>
                                            </div>

                                            <div className="mb-4 flex-grow-1">
                                                <div className="d-flex align-items-center text-secondary mb-2 small">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faBuilding} className="text-muted" />
                                                    </div>
                                                    <span className="text-truncate font-weight-medium" title={item.Empresa?.nome}>
                                                        {item.Empresa ? item.Empresa.nome : <span className="text-muted font-italic">Sem empresa</span>}
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2 small">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faIdCard} className="text-muted" />
                                                    </div>
                                                    <span className="font-weight-medium">
                                                        {item.pessoa ? (item.pessoa === 'F' ? formatCpf(item.codigo) : formatCnpj(item.codigo)) : '-'}
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary small">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="text-muted" />
                                                    </div>
                                                    <span className="text-truncate font-weight-medium">
                                                        {item.Cidade ? `${item.Cidade.nome} / ${item.Estado ? item.Estado.uf : ''}` : '-'}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="mt-2 pt-3 border-top d-flex justify-content-between align-items-center">
                                                <Button
                                                    color="link"
                                                    className="text-decoration-none p-0 text-muted d-flex align-items-center"
                                                    onClick={(event) => handleClickHistory(event, item.id)}
                                                    title="Ver Histórico"
                                                >
                                                    <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mr-2" style={{ width: '32px', height: '32px' }}>
                                                        <FontAwesomeIcon icon={faClock} size="sm" />
                                                    </div>
                                                    <span className="small font-weight-bold">Histórico</span>
                                                </Button>

                                                <div className="d-flex">
                                                    <Button
                                                        color="primary"
                                                        className="d-flex align-items-center justify-content-center mr-2 rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0 }}
                                                        component='a'
                                                        href={`/fazenda/${item.id}`}
                                                        title="Editar Fazenda"
                                                    >
                                                        <FontAwesomeIcon icon={faPen} size="sm" />
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0, backgroundColor: '#e03131' }}
                                                        onClick={(event) => handleClickOpen(event, item.id)}
                                                        title="Excluir Fazenda"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} size="sm" />
                                                    </Button>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <Row>
                                <Col className="d-flex justify-content-center mt-4 mb-4">
                                    <div className="d-flex align-items-center bg-white shadow-sm rounded-pill px-2 py-1">
                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === 1 ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </Button>

                                        <span className="mx-3 text-muted font-weight-bold small">
                                            Página {page} de {totalPages}
                                        </span>

                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === totalPages ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page >= totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </>
                ) : (
                    <Row>
                        <Col className="text-center py-5">
                            <div className="mb-4">
                                <div className="bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center p-4">
                                    <FontAwesomeIcon icon={faWarehouse} size="3x" className="text-muted opacity-50" />
                                </div>
                            </div>
                            <h4 className="text-secondary font-weight-bold">Nenhuma fazenda encontrada</h4>
                            <p className="text-muted">Não encontramos registros com os filtros atuais.</p>
                            {term && (
                                <Button color="primary" outline onClick={() => { setTerm(''); setPage(1); }} className="mt-2 rounded-pill px-4">
                                    Limpar Filtros
                                </Button>
                            )}
                        </Col>
                    </Row>
                )}
            </Container>

            {/* Modal Delete */}
            <Modal isOpen={open} toggle={handleClose} centered>
                <ModalHeader toggle={handleClose} className="border-0 pb-0"></ModalHeader>
                <ModalBody className="text-center pb-4">
                    <div className="mb-3 text-danger bg-light-danger d-inline-block rounded-circle p-3" style={{ backgroundColor: '#ffebee' }}>
                        <FontAwesomeIcon icon={faTrash} size="2x" />
                    </div>
                    <h4 className="mb-2 font-weight-bold">Excluir Fazenda</h4>
                    <p className="text-muted mb-4 small">Esta ação é irreversível. Selecione um motivo para continuar.</p>

                    <FormGroup className="text-left">
                        <Label for="motivo" className="small font-weight-bold text-secondary text-uppercase mb-2">Motivo da Exclusão</Label>
                        <Select
                            classNamePrefix="select"
                            value={renderOptionsMotivo()?.filter(option => option.value == (motivoSelecionado || ''))}
                            onChange={handleSelectChange('motivo')}
                            isSearchable
                            placeholder="Selecione..."
                            options={renderOptionsMotivo()}
                            styles={{
                                control: base => ({
                                    ...base,
                                    borderColor: '#eee',
                                    boxShadow: 'none',
                                    borderRadius: '8px',
                                    padding: '2px',
                                    '&:hover': { borderColor: '#ccc' }
                                })
                            }}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter className="border-0 pt-0 justify-content-center pb-4">
                    <Button color="light" onClick={handleClose} className="mr-2 rounded-pill px-4 font-weight-bold">Cancelar</Button>
                    <Button color="danger" onClick={handleClick} className="rounded-pill px-4 font-weight-bold shadow-sm">Confirmar Exclusão</Button>
                </ModalFooter>
            </Modal>

            <ModalLog toggle={toggle} modal={modal} log={log} id={id} />

            

            <style>{`
                .hover-cards:hover {
                    box-shadow: 0 10px 25px rgba(0,0,0,0.08) !important;
                    transform: translateY(-4px);
                }
            `}</style>
        </div>
    );
}

const mapStateToProps = (state) => {
    return state
};

const connectedFazendaPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Fazenda));
export { connectedFazendaPage as Fazenda };